import { farasod, farasodSubscribe } from "./api"
import { stringify } from "query-string"

const endpoint = "/contract"

export const getContract = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const getContractDeactivationStatus = async () => {
  const response = await farasod.get(`${endpoint}/check/deactivation`)

  return response.data
}

export const getCustomDomain = async () => {
  const response =
    await farasodSubscribe.get(`${endpoint}/custom-domain`)

  return response.data
}

export const getPageDecorationTemplatesAccess = async () => {
  const response =
    await farasodSubscribe.get(`${endpoint}/page-decoration-templates`)

  return response.data
}

export const setCustomDomain = async domain => {
  const response =
    await farasodSubscribe.put(`${endpoint}/custom-domain`, { domain })

  return response.data
}

export const verifyCustomDomain = async () => {
  const response =
    await farasodSubscribe.post(`${endpoint}/custom-domain/verify`)

  return response.data
}

export const removeCustomDomain = async () => {
  await farasodSubscribe.delete(`${endpoint}/custom-domain`)
}

export const updateMarketplaceContract = async data => {
  const response =
    await farasod.patch(`${endpoint}/marketplace`, data)

  return response.data
}

export const getMarketplaceContractReport = async queries => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/marketplace/report?${query}`)

  return response.data
}
